module.exports = __webpack_public_path__ + "assets/RhombusInRectDetailed.084f9d9a70025bf2096bd413b8fe7f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/RhombusInRectDetailed.png
// module id = 555
// module chunks = 0